import script from "./MobilePlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobilePlayer.vue?vue&type=script&lang=ts&setup=true"

import "./MobilePlayer.vue?vue&type=style&index=0&id=5293de3b&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5293de3b"]])

export default __exports__